// extracted by mini-css-extract-plugin
export default {"container":"Box_container__l0P3V","content":"Box_content__fWUwj","icon":"Box_icon__UB9mA","para":"Box_para__fifr7","heading":"Box_heading__pM5Yt"};